import { omitUndefined } from '@shared/helpers/object.helpers';
import { ActivityType } from '@shared/models/design/activities/activity-type.model';
import {
  Activity,
  ActivityMap,
} from '@shared/models/design/activities/activity.model';
import { v4 } from 'uuid';
import { validateActivity } from '@shared/helpers/design/validation/activity.validation';
import { ValidatedValue } from '@shared/validation/validation.models';
import { getDefaultActivityProperties } from '../activities.helpers';
import { SemiPartial } from '@shared/models/type-helpers.model';
/**
 * Create a new activity
 * @param base Partial activity to create. If type is provided, the return type will be narrowed to that activity type.
 * @returns Validated item if valid, otherwise the error
 */
export const createActivityOfType = <
  Type extends ActivityType,
  Activity extends ActivityMap[Type] = ActivityMap[Type],
>(
  type: Type,
  base: Partial<Omit<Activity, 'type'>> = {},
): ValidatedValue<Activity> => {
  const properties = {
    ...getDefaultActivityProperties(type),
    ...omitUndefined(base.properties ?? {}),
  };

  const activity = {
    ...omitUndefined(base),
    properties,
    id: base.id ?? v4(),
    type,
  } as Activity;

  return validateActivity(activity);
};

export const createActivity = <T extends SemiPartial<Activity, 'type'>>(
  base: T,
): ValidatedValue<ActivityMap[T['type']]> => {
  const type = base.type;
  return createActivityOfType<typeof type, ActivityMap[typeof type]>(
    type,
    base,
  ) as ValidatedValue<ActivityMap[T['type']]>;
};
